import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import VueHead from "vue-head";
Vue.use(VueHead);
import Resource from "vue-resource";
Vue.use(Resource);

import home from "./containers/Home";
import project from "./containers/Project";
import about from "./containers/About";
import press from "./containers/Press";
import contact from "./containers/Contact";

// import updates from './containers/Updates'
// import config from './containers/Config'
// import singleupdate from './containers/SingleUpdate'
// import fourzerofour from './containers/404'

// routes
const routes = [
  { name: "home", path: "/", component: home },
  { name: "about", path: "/about", component: about },
  { name: "press", path: "/press", component: press },
  { name: "contact", path: "/contact", component: contact },
  { name: "project", path: "/project/:id", component: project },
  // { name: '404', path: '*', component: fourzerofour }
];

// export router instance
export default new Router({
  mode: "hash",
  base: "",
  routes,
  linkActiveClass: "is-active",
});
